/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TargetBoxOption
 */
export interface TargetBoxOption {
    /**
     * 箱ID
     * @type {number}
     * @memberof TargetBoxOption
     */
    boxId?: number;
    /**
     * 箱唛/箱号
     * @type {string}
     * @memberof TargetBoxOption
     */
    markNo?: string;
}

/**
 * Check if a given object implements the TargetBoxOption interface.
 */
export function instanceOfTargetBoxOption(value: object): value is TargetBoxOption {
    return true;
}

export function TargetBoxOptionFromJSON(json: any): TargetBoxOption {
    return TargetBoxOptionFromJSONTyped(json, false);
}

export function TargetBoxOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetBoxOption {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
    };
}

export function TargetBoxOptionToJSON(json: any): TargetBoxOption {
    return TargetBoxOptionToJSONTyped(json, false);
}

export function TargetBoxOptionToJSONTyped(value?: TargetBoxOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'markNo': value['markNo'],
    };
}

